import request from '@/utils/request'


// 查询商品公式列表
export function listGoodsFormula(query) {
  return request({
    url: '/biz/admin/goods/formula/list',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品公式分页
export function pageGoodsFormula(query) {
  return request({
    url: '/biz/admin/goods/formula/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品公式详细
export function getGoodsFormula(data) {
  return request({
    url: '/biz/admin/goods/formula/detail',
    method: 'get',
    params: data
  })
}

// 新增商品公式
export function addGoodsFormula(data) {
  return request({
    url: '/biz/admin/goods/formula/add',
    method: 'post',
    data: data
  })
}

// 修改商品公式
export function updateGoodsFormula(data) {
  return request({
    url: '/biz/admin/goods/formula/edit',
    method: 'post',
    data: data
  })
}
export function updateGoodsFormulaUse(data) {
  return request({
    url: '/biz/admin/goods/formula/use',
    method: 'post',
    data: data
  })
}

export function updateGoodsFormulaScope(data) {
  return request({
    url: '/biz/admin/goods/formula/scope',
    method: 'post',
    data: data
  })
}

export function updateGoodsFormulaSupplier(data) {
  return request({
    url: '/biz/admin/goods/formula/supplier',
    method: 'post',
    data: data
  })
}

// 删除商品公式
export function delGoodsFormula(data) {
  return request({
    url: '/biz/admin/goods/formula/delete',
    method: 'post',
    data: data
  })
}
